import { Axios } from "../../../../../../legacyComponents/util"

export default async function uploadAgeTemplate(props, file,setData) {
    // let {employerId } = props
	const url = `/webPage/classMaxBenefitFile`;
    // const url = `/employer/${employerId}/classMaxBenefitFile/view`
    const response = await Axios.upload(url, file)

    const maxBenefit = response?.data
    const selfBenefit = maxBenefit?.SELF;
    
    if(setData != undefined && setData != null)
    {
        setData(selfBenefit)
    }
    return true
}
